<template>
    <HeaderMobile v-if="!pageMode && !hideHeader && (isPWA || isTgApp)" />
    <HeaderDesktop v-if="!pageMode && !hideHeader && !isTgApp && !isPWA" 
        :menuTop="menuTop"
        :menuPersonal="menuPersonal"
        :menuMob="menuMob"/>
</template>


<script>
import Connect from '@/assets/js/Connect.js'
import Helper from '@/assets/js/Helper.js'
import HeaderDesktop from '@/components/sides/header/Desktop.vue'
import HeaderMobile from '@/components/sides/header/Mobile.vue'

export default {
    name: 'Header',
    props: ['menuTop', 'menuPersonal', 'menuMob'],
    data() {
        return {
            
        }
    },
    components: {
        HeaderDesktop,
        HeaderMobile
    },
    methods: {

    },
    computed: {
        screen_size() { return this.$store.getters.StateScreenSize },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
        pageMode: function () {
            try { return this.$route.meta.pageMode } 
            catch { return false }
        },
        hideHeader: function () {
            if(this.$route.name=='Transfer Details' && (this.screen_size=='sm' || this.screen_size=='xs')) return true
            if(this.$route.name=='MerchantTransferDetail' && (this.screen_size=='sm' || this.screen_size=='xs')) return true
            if(this.$route.name=='AdmTransferDetail' && (this.screen_size=='sm' || this.screen_size=='xs')) return true
            if(this.$route.name=='Get Bill' && (this.screen_size=='sm' || this.screen_size=='xs')) return true
            if(this.$route.name=='Get Deal' && (this.screen_size=='sm' || this.screen_size=='xs')) return true
            if(this.$route.name=='PersonalDeal' && (this.screen_size=='sm' || this.screen_size=='xs')) return true
            return false
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    }
}
</script>